import type { JotformBackup } from '@/services/jotformService';

type FallbackFormat = 'display' | 'filename';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function getJotformBackupFormName(
  backup: Pick<JotformBackup, 'form_data_json' | 'form_id_external'>,
  fallbackFormat: FallbackFormat = 'filename'
): string {
  const payload = backup.form_data_json;

  if (isRecord(payload)) {
    const formValue = payload.form;
    if (isRecord(formValue) && typeof formValue.title === 'string' && formValue.title.trim()) {
      return formValue.title;
    }

    if (typeof payload.name === 'string' && payload.name.trim()) {
      return payload.name;
    }
  }

  return fallbackFormat === 'display'
    ? `Form ${backup.form_id_external}`
    : `form-${backup.form_id_external}`;
}
